import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue'
import SupplierHome from '../views/SupplierHome.vue'

Vue.use(VueRouter)

const routes = [
    // ==================== 供应商门户路由 ====================
    {
        path: '/supplier-login',
        name: 'SupplierLogin',
        component: () => import('../views/SupplierLogin.vue')
    },
    {
        path: '/supplier-register',
        name: 'SupplierRegister',
        component: () => import('../views/SupplierRegister.vue')
    },
    {
        path: '/supplier-home',
        component: SupplierHome,
        redirect: '/supplier-home/dashboard',
        children: [
            { path: 'dashboard', name: 'SupplierDashboard', component: () => import('../views/supplier/SupplierDashboard.vue') },
            { path: 'bidding', name: 'SupplierBiddingView', component: () => import('../views/supplier/SupplierBidding.vue') },
            { path: 'quotes', name: 'SupplierQuotesView', component: () => import('../views/supplier/SupplierQuotes.vue') },
            { path: 'qa', name: 'SupplierQAView', component: () => import('../views/supplier/SupplierQA.vue') },
            { path: 'contracts', name: 'SupplierContractsView', component: () => import('../views/supplier/SupplierContracts.vue') },
            { path: 'reconciliation', name: 'SupplierReconciliationView', component: () => import('../views/supplier/SupplierReconciliation.vue') },
            { path: 'progress', name: 'SupplierProgressView', component: () => import('../views/supplier/SupplierProgress.vue') },
            { path: 'records', name: 'SupplierRecordsView', component: () => import('../views/supplier/SupplierRecords.vue') },
            { path: 'drawings', name: 'SupplierDrawings', component: () => import('../views/supplier/SupplierDrawings.vue') }
        ]
    },

    // ==================== OA 管理后台路由 ====================
    {
        path: '/Login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/',
        component: Layout,
        redirect: '/pm',
        children: [
            // OA协同办公
            { path: 'pm', name: 'ProjectManagement', component: () => import('../views/ProjectManagement.vue') },
            { path: 'project-detail/:id', name: 'ProjectDetail', component: () => import('../views/ProjectDetail.vue') },
            { path: 'company-project-stats', name: 'CompanyProjectStats', component: () => import('../views/CompanyProjectStats.vue') },
            { path: 'drawing-library', name: 'DrawingLibrary', component: () => import('../views/DrawingLibrary.vue') },
            { path: 'quote-mgmt', name: 'ProjectQuotePrice', component: () => import('../views/ProjectQuotePrice.vue') },
            { path: 'quote-material', name: 'ProjectQuoteMaterial', component: () => import('../views/ProjectQuoteMaterial.vue') },
            { path: 'personnel', name: 'PersonnelManagement', component: () => import('../views/PersonnelManagement.vue') },
            { path: 'financial', name: 'FinancialManagement', component: () => import('../views/FinancialManagement.vue') },
            { path: 'user', name: 'UserManagement', component: () => import('../views/UserManagement.vue') },
            { path: 'role', name: 'RoleManagement', component: () => import('../views/RoleManagement.vue') },
            { path: 'department', name: 'DepartmentManagement', component: () => import('../views/DepartmentManagement.vue') },

            // 供应链管理
            { path: 'supplier-mgmt', name: 'SupplierManagement', component: () => import('../views/SupplierManagement.vue') },
            { path: 'supplier-ledger', name: 'SupplierLedger', component: () => import('../views/SupplierLedger.vue') },
            { path: 'purchasematerialtype', name: 'MaterialCategory', component: () => import('../views/MaterialCategory.vue') },
            { path: 'purchasemateriallist', name: 'MaterialList', component: () => import('../views/MaterialList.vue') },
            { path: 'supplier-evaluation', name: 'SupplierEvaluation', component: () => import('../views/SupplierEvaluation.vue') },

            // 招投标管理
            { path: 'bidding-project', name: 'BiddingProject', component: () => import('../views/BiddingProject.vue') },
            { path: 'bidding-registration', name: 'BiddingRegistration', component: () => import('../views/BiddingRegistration.vue') },
            { path: 'bidding-notice', name: 'BiddingNoticeMgmt', component: () => import('../views/BiddingNoticeMgmt.vue') },
            { path: 'bidding-evaluation', name: 'BiddingEvaluation', component: () => import('../views/BiddingEvaluation.vue') },
            { path: 'bidding-award', name: 'BiddingAward', component: () => import('../views/BiddingAward.vue') },
            { path: 'bidding-document', name: 'BiddingDocument', component: () => import('../views/BiddingDocument.vue') },
            { path: 'bidding-qa', name: 'BiddingQA', component: () => import('../views/BiddingQA.vue') },
            { path: 'bidding-section', name: 'BiddingSection', component: () => import('../views/BiddingSection.vue') },
            { path: 'bidding-archive', name: 'BiddingArchive', component: () => import('../views/BiddingArchive.vue') },
            { path: 'cost-analysis', name: 'CostAnalysis', component: () => import('../views/CostAnalysis.vue') },

            // 合同履约
            { path: 'contract-mgmt', name: 'ContractManagement', component: () => import('../views/ContractManagement.vue') },
            { path: 'contract-progress', name: 'ContractProgress', component: () => import('../views/ContractProgress.vue') },
            { path: 'payment-mgmt', name: 'PaymentManagement', component: () => import('../views/PaymentManagement.vue') },
            { path: 'acceptance-mgmt', name: 'AcceptanceMgmt', component: () => import('../views/AcceptanceMgmt.vue') },

            // 系统工具
            { path: 'notification-center', name: 'NotificationCenter', component: () => import('../views/NotificationCenter.vue') },
            { path: 'approval-center', name: 'ApprovalCenter', component: () => import('../views/ApprovalCenter.vue') },
            { path: 'approval-design', name: 'FlowDesign', component: () => import('../views/FlowDesign.vue') },
            { path: 'approval-archive', name: 'ApprovalArchive', component: () => import('../views/ApprovalArchive.vue') },
            { path: 'approval-efficiency', name: 'ApprovalEfficiency', component: () => import('../views/ApprovalEfficiency.vue') },
            { path: 'attendance', name: 'Attendance', component: () => import('../views/Attendance.vue') },
            { path: 'duty-mgmt', name: 'DutyManagement', component: () => import('../views/DutyManagement.vue') },
            { path: 'schedule', name: 'Schedule', component: () => import('../views/Schedule.vue') },
            { path: 'workbench', name: 'Workbench', component: () => import('../views/Workbench.vue') },
            { path: 'document-center', name: 'DocumentCenter', component: () => import('../views/DocumentCenter.vue') },
            { path: 'system-log', name: 'SystemLog', component: () => import('../views/AuditLog.vue') },
            { path: 'dashboard', name: 'AdminDashboard', component: () => import('../views/AdminDashboard.vue') },
            { path: 'security-risk', name: 'SecurityRisk', component: () => import('../views/SecurityRisk.vue') },

            // 权限配置
            { path: 'role-page-permission', name: 'RolePagePermission', component: () => import('../views/RolePagePermission.vue') }
        ]
    }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
    // 供应商门户路由
    const supplierPaths = [
        '/supplier-login', '/supplier-register',
        '/supplier-home', '/supplier-home/dashboard',
        '/supplier-home/bidding', '/supplier-home/quotes',
        '/supplier-home/contracts', '/supplier-home/reconciliation', '/supplier-home/progress',
        '/supplier-home/qa', '/supplier-home/records', '/supplier-home/drawings'
    ]
    if (supplierPaths.includes(to.path)) {
        if (to.path === '/supplier-login' || to.path === '/supplier-register') { next(); return }
        const supplierToken = localStorage.getItem('supplier_token')
        if (!supplierToken) { next('/supplier-login'); return }
        next(); return
    }
    // OA后台 supplier-mgmt 特殊处理
    if (to.path === '/supplier-mgmt') {
        const token = localStorage.getItem('token')
        if (!token) { next('/Login'); return }
        next(); return
    }
    // 其他管理后台路由
    if (to.path !== '/Login') {
        const token = localStorage.getItem('token')
        if (!token) { next('/Login'); return }
    }
    next()
})

export default router
